import { render, staticRenderFns } from "./RoleEditDetail.vue?vue&type=template&id=0dba7c1c&"
import script from "./RoleEditDetail.vue?vue&type=script&lang=js&"
export * from "./RoleEditDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports